var React = require('react');

function ShopArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shop-arrow-right"),React.createElement("path",{"d":"M391.428 281.346l-220.152 220.145c-14.005 14.011-36.71 14.011-50.708 0-13.999-13.998-13.999-36.703 0-50.7l194.801-194.794-194.794-194.788c-13.999-14.005-13.999-36.706 0-50.705 13.999-14.005 36.703-14.005 50.708 0l220.152 220.149c7 7.002 10.495 16.171 10.495 25.344 0 9.177-3.502 18.352-10.5 25.351z","key":1})]);
}

ShopArrowRight.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ShopArrowRight;

ShopArrowRight.default = ShopArrowRight;
